import React from "react";
import { useDrag } from "react-dnd";
import {
  Box,
  Button,
  Card,
  CardContent,
  Tooltip,
  Typography,
} from "@mui/material";
import { Candidate, DragItem, ItemTypes } from "../types/CandidateBoardTypes";
import { formatDate } from "../../../../helpers/formatingFunctions";
import CommentIcon from "@mui/icons-material/Comment";
import dayjs, { MOLDOVA_TIMEZONE } from "../../../../utils/dayjsTimezone";

interface CandidateCardProps {
  candidate: Candidate;
  onDoubleClick: (candidate: Candidate) => void;
}

const CandidateCard: React.FC<CandidateCardProps> = ({
  candidate,
  onDoubleClick,
}) => {
  const [{ isDragging }, drag] = useDrag<
    DragItem,
    void,
    { isDragging: boolean }
  >(() => ({
    type: ItemTypes.CANDIDATE,
    item: { id: candidate.id, currentStatus: candidate.status },
    collect: (monitor) => ({
      isDragging: monitor.isDragging(),
    }),
  }));

  return (
    <Card
      ref={drag}
      onDoubleClick={() => onDoubleClick(candidate)}
      sx={{
        opacity: isDragging ? 0.5 : 1,
        marginBottom: 1,
        cursor: "move",
        width: 250,
        maxWidth: "100%",
      }}
      variant="outlined"
    >
      <CardContent sx={{ padding: "4px 8px" }}>
        <Button
          onClick={() => onDoubleClick(candidate)}
          size="small"
          sx={{ display: { xs: "inline-flex", lg: "none" } }}
        >
          View candidate
        </Button>
        <Typography
          variant="subtitle2"
          noWrap
        >{`${candidate.firstName} ${candidate.lastName}`}</Typography>
        <Typography variant="caption" color="textSecondary" noWrap>
          Position: {candidate.position}
        </Typography>
        <br />
        <Typography variant="caption" color="textSecondary" noWrap>
          Email: {candidate.email}
        </Typography>
        <br />
        <Typography variant="caption" color="textSecondary" noWrap>
          Phone: {candidate.phoneNumber}
        </Typography>
        <br />
        <Typography variant="caption" color="textSecondary" noWrap>
          Applied Date: {formatDate(candidate.appliedDate)}
        </Typography>
        <br />
        {candidate.status === "SCHEDULED" && candidate.scheduledFor && (
          <Typography variant="caption" color="textSecondary" noWrap>
            Scheduled:{" "}
            {dayjs
              .utc(candidate.scheduledFor)
              .tz(MOLDOVA_TIMEZONE)
              .format("DD MMM YYYY HH:mm")}
          </Typography>
        )}
        <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 1 }}>
          {candidate.hasComments && (
            <Tooltip title="Has Comments">
              <CommentIcon
                fontSize="small"
                sx={{ color: "blue", marginRight: 1 }}
              />
            </Tooltip>
          )}
        </Box>
      </CardContent>
    </Card>
  );
};

export default CandidateCard;
